<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.947 10.6787L13.4328 12.1283L13.7534 13.1104C14.5921 15.715 15 17.2965 15 18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18C9 17.2121 9.51165 15.3228 10.5672 12.1283L11.053 10.6787C11.36 9.77375 12.64 9.77375 12.947 10.6787ZM12 3C17.5228 3 22 7.47715 22 13C22 15.0057 21.4073 16.9257 20.3146 18.5576C20.0073 19.0165 19.3862 19.1394 18.9272 18.8321C18.4683 18.5248 18.3454 17.9037 18.6527 17.4448C19.5267 16.1397 20 14.6064 20 13C20 8.58172 16.4183 5 12 5C7.58172 5 4 8.58172 4 13C4 14.6064 4.47334 16.1397 5.34728 17.4448C5.65457 17.9037 5.53166 18.5248 5.07275 18.8321C4.61385 19.1394 3.99273 19.0165 3.68544 18.5576C2.59272 16.9257 2 15.0057 2 13C2 7.47715 6.47715 3 12 3ZM12 14.199L11.6716 15.2596L11.4445 16.0306C11.1499 17.061 11 17.7283 11 18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18C13 17.6678 12.7759 16.7441 12.3371 15.2884L12 14.199Z"
    fill="currentColor"
  />
</svg>
